import http from '../jslibs/axios/http';

// 首页服务列表
export  const getSettingSEOList = (data) => (http.get('/v1/cms/SettingSEO', data));

// 首页服务详情
export  const getSettingSeoDetail = id => (http.get(`/v1/cms/SettingSEO/${id}`));

// 编辑服务
export  const editSettingSeo = data => (http.put(`/v1/cms/SettingSEO/${data.id}`, data));